import React from 'react'

function Icon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      <g clipPath="url(#clip0_1917_21602)">
        <path
          fill="#202020"
          d="M19.2 15.857H21v1.714H3v-1.714h1.8v-6c0-1.818.759-3.563 2.109-4.849S10.09 3 12 3c1.91 0 3.74.722 5.091 2.008 1.35 1.286 2.109 3.03 2.109 4.85v6zm-1.8 0v-6a5.022 5.022 0 00-1.582-3.636A5.54 5.54 0 0012 4.714a5.54 5.54 0 00-3.818 1.507A5.022 5.022 0 006.6 9.857v6h10.8zm-8.1 3.429h5.4V21H9.3v-1.714z"
        ></path>
        <rect width="10" height="10" x="15" y="-1" fill="#05944F" rx="5"></rect>
        <rect width="10" height="10" x="15" y="-1" stroke="#F4F4F4" strokeWidth="2" rx="5"></rect>
      </g>
      <defs>
        <clipPath id="clip0_1917_21602">
          <path fill="#fff" d="M0 0H24V24H0z"></path>
        </clipPath>
      </defs>
    </svg>
  )
}

export default Icon
